// Module
var code = `<template>
  <require from="./grid-columns-dialog.scss"></require>

  <mdc-dialog class="grid-columns-dialog">
    <mdc-dialog-title>Input options</mdc-dialog-title>
    <mdc-dialog-content>
      <div class="grid-columns-dialog__info">Choose which columns you would like to see in your table.</div>
      <mdc-list>
        <mdc-list-item reorderable-repeat.for="c of model.columns" reorderable-after-reordering="itemReordered" disable-ripple class="grid-columns-dialog__item">
          <mdc-checkbox mdc-list-item-leading checked.bind="c.visible"></mdc-checkbox>
          \${c.header}
          <mdc-icon mdc-list-item-trailing class="grid-columns-dialog__handle">drag_handle</mdc-icon>
        </mdc-list-item>
      </mdc-list>
    </mdc-dialog-content>
    <mdc-dialog-actions>
      <button mdc-button outlined data-mdc-dialog-action="cancel">Cancel</button>
      <div class="mdc-dialog__action-spacer"></div>
      <button mdc-button outlined data-mdc-dialog-action="reset">Reset</button>
      <button mdc-button raised data-mdc-dialog-action="save">Save</button>
    </mdc-dialog-actions>
  </mdc-dialog>
</template>
`;
// Exports
export default code;